class FlashOfferCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.flash-offer__slide'));
    this.dots = Array.from(this.querySelectorAll('.flash-offer__dot'));
    this.prevButton = this.querySelector('.flash-offer__arrow--prev');
    this.nextButton = this.querySelector('.flash-offer__arrow--next');
    this.currentIndex = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 6000;

    this.prevButton?.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
    this.nextButton?.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    this.querySelectorAll('[data-copy-code]').forEach((button) => {
      button.addEventListener('click', () => this.copyCode(button));
    });

    this.initCountdown();

    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
    }
  }

  disconnectedCallback() {
    clearInterval(this.autoplayTimer);
    clearInterval(this.countdownTimer);
  }

  goToSlide(index) {
    const total = this.slides.length;
    this.currentIndex = (index + total) % total;

    this.slides.forEach((slide, i) => {
      const isActive = i === this.currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    this.dots.forEach((dot, i) => {
      const isActive = i === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });

    this.restartAutoplay();
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => {
      this.goToSlide(this.currentIndex + 1);
    }, this.autoplayInterval);
  }

  restartAutoplay() {
    if (!this.autoplay || this.slides.length < 2) return;
    clearInterval(this.autoplayTimer);
    this.startAutoplay();
  }

  copyCode(button) {
    const code = button.dataset.copyCode;
    if (!code || !navigator.clipboard) return;
    navigator.clipboard.writeText(code).then(() => {
      button.classList.add('is-copied');
      clearTimeout(button._copyTimeout);
      button._copyTimeout = setTimeout(() => button.classList.remove('is-copied'), 1500);
    });
  }

  initCountdown() {
    const el = this.querySelector('.flash-offer__countdown');
    if (!el) return;

    const endTime = new Date(el.dataset.countdownEnd).getTime();
    if (Number.isNaN(endTime)) return;

    const daysEl = el.querySelector('[data-unit="days"]');
    const hoursEl = el.querySelector('[data-unit="hours"]');
    const minutesEl = el.querySelector('[data-unit="minutes"]');
    const secondsEl = el.querySelector('[data-unit="seconds"]');
    const pad = (value) => String(value).padStart(2, '0');

    const tick = () => {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        el.textContent = el.dataset.endedText || '';
        clearInterval(this.countdownTimer);
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    tick();
    this.countdownTimer = setInterval(tick, 1000);
  }
}

customElements.define('flash-offer-carousel', FlashOfferCarousel);
